import firebase from '@/firebase'

export default (): firebase.auth.GoogleAuthProvider => {
    const provider = new firebase.auth.OAuthProvider('apple.com')
    provider.addScope('email')
    provider.addScope('name')

    return provider
}
